import axios from "../api/api";
import { API_URL } from "../constants";
import ServiceHelper from "../helper/service.helper";
import { setUserWallet } from "../redux/actions/auth.action";

const getLeaderboard = (params, source) => {
  return axios
    .get(
      `${API_URL}/v1/main/leaderboard?${ServiceHelper.buildParamsForGET(params)}`,
      {
        cancelToken: source.token,
      }
    )
    .then((response) => {
      return response.data;
    });
};

const getListItems = (params, source) => {
  return axios
    .get(
      `${API_URL}/v1/main/activities?${ServiceHelper.buildParamsForGET(params)}`,
      {
        cancelToken: source.token,
      }
    )
    .then((response) => {
      return response.data;
    });
};

const getYearInSport = (params, source) => {
  return axios
    .get(
      `${API_URL}/v1/main/year-in-sport?${ServiceHelper.buildParamsForGET(params)}`,
      {
        cancelToken: source.token,
      }
    )
    .then((response) => {
      return response.data;
    });
};

const getItem = (id, source) => {
  return axios
    .get(`${API_URL}/v1/main/activity/${id}`, {
      cancelToken: source.token,
    })
    .then((response) => {
      return response.data;
    });
};

const getUsersByNoteId = (id, source) => {
  return axios
    .get(`${API_URL}/v1/main/note-users/${id}`, {
      cancelToken: source.token,
    })
    .then((response) => {
      return response.data;
    });
};

const getListItemBids = (params, source) => {
  return axios
    .get(
      `${API_URL}/v1/bidding/bids?${ServiceHelper.buildParamsForGET(params)}`,
      {
        cancelToken: source.token,
      }
    )
    .then((response) => {
      return response.data;
    });
};

const createItem = (params, source) => {
  return axios
    .post(`${API_URL}/v1/main/note`, ServiceHelper.buildParamsForPOST(params), {
      cancelToken: source.token,
    })
    .then((response) => {
      return response.data;
    });
};

const updateItem = (params, source) => {
  return axios
    .put(`${API_URL}/v1/main/note`, ServiceHelper.buildParamsForPOST(params), {
      cancelToken: source.token,
    })
    .then((response) => {
      return response.data;
    });
};

const publishItem = (params, source) => {
  return axios
    .put(`${API_URL}/v1/main/note`, ServiceHelper.buildParamsForPOST(params), {
      cancelToken: source.token,
    })
    .then((response) => {
      return response.data;
    });
};

const deposit = (params) => {
  return axios
    .put(`${API_URL}/v1/auth/user`, ServiceHelper.buildParamsForPOST(params))
    .then((response) => {
      return response.data;
    });
};

const bid = (params) => {
  return axios
    .post(`${API_URL}/v1/bidding/bid`, ServiceHelper.buildParamsForPOST(params))
    .then((response) => {
      return response.data;
    });
};

const activityService = {
  getLeaderboard,
  getListItems,
  getYearInSport,
  getItem,
  getUsersByNoteId,
  getListItemBids,
  createItem,
  updateItem,
  publishItem,
  deposit,
  bid,
};

export default activityService;
